import { format } from "date-fns";
import React, { useState } from "react";
import { Colors } from "../../../../helpers/Colors";
import { Durations } from "../../../../helpers/Durations";
import { fontSize } from "../../../../helpers/fontSize";
import { makeStyles } from "@mui/styles";
import { useSelector } from "react-redux";
import { Confirm_Modal_useStyles } from "../../../../useStyles/Confirm_Modal_useStyles";

const Confirm_Modal = ({ user, ConfirmReservationHandler }) => {
  const classes = Confirm_Modal_useStyles();

  const [email, setEmail] = useState(user.email || "email");
  const [employeeName, setEmployeeName] = useState(user.name || "employeeName");

  const reservation = useSelector((state) => state.reservation.details);
  const reservation_cabinName = useSelector(
    (state) => state.reservation.cabinName
  );

  // var hello =
  //   reservation.length > 0
  //     ? reservation[0].addTimetoStart === Durations.minutes15
  //       ? format(reservation[0].startTimePlus15mins, "hh:mm a")
  //       : reservation[0].addTimetoStart === Durations.minutes30
  //       ? format(reservation[0].startTimePlus30mins, "hh:mm a")
  //       : reservation[0].addTimetoStart === Durations.hour1
  //       ? format(reservation[0].startTimePlus1hr, "hh:mm a")
  //       : format(reservation[0].endTime, "hh:mm a")
  //     : "00:00 AM";

  // console.log("reservation ---> " + JSON.stringify(reservation));
  // console.log("hello ---> " + hello);
  // console.log("hello ---> " + hello);

  return (
    <main>
      <section className={classes.DetailsCon}>
        <section className={classes.Cabin_Date}>
          {/* Cabin */}
          <div className="Cabin">
            <label>Cabin</label>
            <input
              className=""
              type={"text"}
              disabled
              value={
                reservation_cabinName.length > 0
                  ? reservation_cabinName[0].cabinName
                  : "cabinName"
                // cabinName
                // reservation !== null
                //   ? reservation[0].cabinName
                //   : "cabinName"
              }
            />
          </div>
          {/* Date */}
          <div className="Cabin">
            <label>Date</label>
            <input
              className=""
              type={"text"}
              disabled
              value={
                reservation.length > 0
                  ? format(reservation[0].selectedDay, "dd/MM/yyyy")
                  : "08/10/2001"
              }
            />
          </div>
        </section>
        <section className={classes.Cabin_Date}>
          {/* StartTime */}
          <div className="Cabin">
            <label>Start Time</label>
            <input
              className=""
              type={"text"}
              disabled
              value={
                reservation.length > 0
                  ? format(reservation[0].startTime, "hh:mm a")
                  : "00:00 AM"
              }
            />
          </div>
          {/* EndTime */}
          <div className="Cabin">
            <label>End Time</label>
            <input
              className=""
              type={"text"}
              disabled
              value={
                // format(reservation[0].endTime, "hh:mm a")
                reservation.length > 0
                  ? reservation[0].addTimetoStart === Durations.minutes15
                    ? format(reservation[0].startTimePlus15mins, "hh:mm a")
                    : reservation[0].addTimetoStart === Durations.minutes30
                    ? format(reservation[0].startTimePlus30mins, "hh:mm a")
                    : reservation[0].addTimetoStart === Durations.hour1
                    ? format(reservation[0].startTimePlus1hr, "hh:mm a")
                    : format(reservation[0].endTime, "hh:mm a")
                  : "00:00 AM"
              }
            />
          </div>
        </section>
        <section className={classes.Cabin_Date}>
          {/* Email */}
          <div className="Cabin">
            <label>Email</label>
            <input
              className=""
              type={"text"}
              value={email}
              disabled
              // onChange={(e) => setEmail(e.target.value)}
            />
          </div>
          {/* Name */}
          <div className="Cabin">
            <label>Name</label>
            <input
              className=""
              type={"text"}
              disabled
              value={employeeName}
              // onChange={(e) => setEmployeeName(e.target.value)}
            />
          </div>
        </section>
      </section>
      <section
        className={classes.Container_Six}
        onClick={ConfirmReservationHandler}
      >
        <div className="Submit_Button">
          <div className="SubmitText_Con">
            <button type="submit">Confirm Reservation</button>
          </div>
        </div>
      </section>
    </main>
  );
};

export default Confirm_Modal;
